import React, { useState } from "react";
import { ReactSession} from 'react-client-session';
import { useNavigate } from "react-router-dom";

const Login = () => {

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(null);
    const navigate = useNavigate();


    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            const response = await fetch('https://projects.sninfoserv.com/welb-api/admin/login/', {
                method:'POST',
                header:{
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email, 
                    password: password
                })
            });

            const data = await response.json();

            if(data.status === "success") {
                ReactSession.set("welbeingId", data.data.id);
                ReactSession.set("welbeingName", data.data.name);
                ReactSession.set("welbeingEmail", data.data.email);
                navigate("/dashboard");
            } else {
                setError(data.error?.message || "Invalud Email or Password");
            }
        } catch(err) {
            setError('Network error.Please try again');
            console.error('Login error:', err);
        } 
    };

    return (
        <>
            <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
                <div class="position-relative overflow-hidden radial-gradient min-vh-100 d-flex align-items-center justify-content-center">
                    <div class="d-flex align-items-center justify-content-center w-100">
                        <div class="row justify-content-center w-100">
                            <div class="col-md-8 col-lg-6 col-xxl-3">
                                <div class="card mb-0">
                                    <div class="card-body">
                                        <a href="" class="text-nowrap logo-img text-center d-block mb-5 w-100">
                                            <img src="assets/images/logo.png" width="180" alt=""/>
                                        </a>
                                        <form onSubmit={handleSubmit}>
                                            <div class="mb-3">
                                                <label for="exampleInputEmail1" class="form-label">Username</label>
                                                <input type="email" class="form-control" name="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                            </div>
                                            <div class="mb-4">
                                                <label for="exampleInputPassword1" class="form-label">Password</label>
                                                <input type="password" class="form-control" name="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required/>
                                            </div>
                                            {error && (
                                                <div className="alert alert-danger mb-3">{error}</div>
                                            )}
                                            <input type="submit" class="btn btn-primary w-100 py-8 mb-4 rounded-2" value="Sign In" />
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Login;